<template>
    <div class="choose-container">
        <back title="选择品牌车型"></back>
        <sob-search-bar
                @on-result-click="resultClick"
                @on-change="getResult"
                auto-fixed
                placeholder="请输入品牌、车系"
                :results="results"
                :noResultMsg="noResultMsg"
                v-model="searchValue"
                auto-scroll-to-top
                @on-focus="onFocus"
                @on-cancel="onCancel"
                @on-submit="onSubmit"
                ref="search">
        </sob-search-bar>
        <div class="car-picker-demo-wrapper" v-if="showPicker">
            <div class="picker-content">
                <som-car-picker
                        :actived-value="value"
                        ref="carPicker"
                        scene="3"
                        :filterModelMethod="filterModelMethod"
                        :seriesDataUrl="getSeriesDatafn"
                        :modelDataUrl="getModelData"
                        :brandDataUrl="getBrandData"
                        @onSelected="onSelected"
                        @onSelectedBrand="onSelectedBrand"
                        @on-series-click="onSeriesClick"
                        :showUnlimitBrand="false"
                        :showUnlimitSeries="false"
                        :showUnlimitModel="false"
                >
                    <som-selector-item title="我的历史" index="历史" v-show="historyData.length > 0">
                        <div class="selector-item-body-custom">
                            <div
                                    v-for="brandItem in historyData"
                                    @click="openSeriesSection(brandItem)"
                                    :key="brandItem.code"
                                    :class="['card-item', {'card-item-selected': selectedBrands.filter(selectedBrandItem => selectedBrandItem.code === brandItem.code).length > 0}]">
                                <img class="card-item-image" :src="brandItem.image">
                                <span class="card-item-span">{{brandItem.name}}</span>
                            </div>
                        </div>
                    </som-selector-item>

                    <div slot="modelFilter">
                        <som-selector-item title="变速箱">
                            <som-tag-group class="citys" column="three">
                                <som-tag
                                    :plain="filter.gearBox === item"
                                    @click.native="filter.gearBox == item ? filter.gearBox = '' : filter.gearBox = item"
                                    :type="filter.gearBox === item ? 'primary': 'default'"
                                    v-for="item in gearBoxFilterOptions"
                                    :key="item">
                                    {{item}}
                                </som-tag>
                            </som-tag-group>
                        </som-selector-item>
                        <som-selector-item title="排量">
                            <som-tag-group class="citys" column="three">
                                <som-tag
                                    :plain="filter.engineVolume === item"
                                    @click.native="filter.engineVolume == item ? filter.engineVolume = '' : filter.engineVolume = item"
                                    :type="filter.engineVolume === item ? 'primary': 'default'"
                                    v-for="item in engineFilterOptions"
                                    :key="item">
                                    {{item}}
                                </som-tag>
                            </som-tag-group>
                        </som-selector-item>
                    </div>
                </som-car-picker>
            </div>
        </div>
        <div class="brand-loading" v-show="isShowLoading"><span class="img"></span>正在加载...</div>
    </div>
</template>
<script>
    import store from '../vuex/store';
    import cMonitor from "@/components/common/c-monitor";
    import back from "@/components/common/back";
    import HttpRequest from '@souche-f2e/http-request';
    import Api from "../../assets/js/Auction"
    import Tower from "@souche-f2e/tower";

    export default {
        store,
        name: "BrandSelector",
        data() {
            return {
                value: {},
                scene: 1,
                showPicker: true,
                currentScene: {},
                selectedBrands: [],
                historyData: [],
                results: [],
                autoFixed: false,
                searchValue: '',
                value1: '1',
                gearBoxFilterOptions: [],
                engineFilterOptions: [],
                filter: {
                    gearBox: '',
                    engineVolume: '',
                },
                getSeriesData: [],
                currentSeries: {},
                noResultMsg: '',
                isShowLoading:false,
            };
        },
        components: {
            cMonitor,
            back
        },
        watch: {
            filter: {
                handler() {
                    let carPicker = this.$refs.carPicker;
                    // 调用内部过滤方法，每个车型的过滤根据你的 filterModelMethod 方法。
                    carPicker.filterModelData();

                    // 当你自定义后端方法的时候更为简单
                    // 你也可以调用后端接口重新获取过滤数据，再通过内部 setModel 方法更新车型数据。
                    //carPicker.getModel(this.currentSeries, carPicker.setModel.bind(carPicker));
                    // modelDataUrl 方法示例。 eg:
                    // HttpRequest.jsonp('https://car-model.souche.com/model/getModelBySeries.jsonp', {
                    //     series_code: this.currentSeries.code,
                    //     modelYear: this.filter.modelYear
                    // });
                },
                deep: true
            },
         
        },
        methods: {
            headerFn() {//头部
                document.title = '选择品牌车型';
                Tower.setWebViewTitle('选择品牌车型');
            },
            onSeriesClick(series) {
                this.currentSeries = series;
                this.filter.gearBox='';
                this.filter.engineVolume='';
                this.gearBoxFilterOptions=[],
                this.engineFilterOptions=[],
                this.getFilterOptions(series.code);
            },
            getSeriesDatafn(brandCode){
                this.isShowLoading=true;
                return new Promise((resolve, rejects) => {
                    return HttpRequest.post(`${process.env.CYP_BASE_URL}/carModel/querySeriesByBrand`,
                        {
                            brandCode: brandCode,
                            userId: this.$route.query.userId ? this.$route.query.userId : ''
                        }
                    ).then(res => {
                        resolve(res);
                        this.isShowLoading=false;
                    }).catch(res=>{
                        this.isShowLoading=false;
                    })
                })
            },
            getModelData(seriesCode) {
                this.isShowLoading=true;
                return new Promise((resolve, rejects) => {
                    return HttpRequest.post(`${process.env.CYP_BASE_URL}/carModel/modelList`, {
                        seriesCode: seriesCode,
                        userId: this.$route.query.userId ? this.$route.query.userId : ''
                    }).then(res => {
                        this.isShowLoading=false;
                        resolve(res);
                    }).catch(res => {
                        this.isShowLoading=false;
                    })
                })
            },
            getBrandData() {
                this.isShowLoading=true;
                return new Promise((resolve, rejects) => {
                    return HttpRequest.jsonp(`https://car-model.souche.com/brand/brands.jsonp`, {
                        userId: this.$route.query.userId ? this.$route.query.userId : ''
                    }).then(res => {
                        resolve(res);
                        this.isShowLoading=false;
                    }).catch(res=>{
                        this.isShowLoading=false;
                    })
                })
            },
            filterModelMethod(item) {
                if(this.filter.gearBox && this.filter.engineVolume){
                    return item.engineVolume === this.filter.engineVolume && item.gearBox === this.filter.gearBox
                }else if(this.filter.gearBox && !this.filter.engineVolume){
                    return item.gearBox === this.filter.gearBox || !this.filter.gearBox;
                }else if(!this.filter.gearBox && this.filter.engineVolume){
                    return item.engineVolume === this.filter.engineVolume || !this.filter.engineVolume;
                }else{
                    return true
                }
            },
            onSelected(data) {
                console.log(data)
                this.$store.commit('updateBrand', {
                    modelName: data.model.name,
                    modelCode: data.model.code,
                    brandName: data.model.brandName,
                    modelYear: data.model.modelYear,
                    seriesCode: data.model.parent,
                    brandCode: data.model.brandCode
                });
                this.$router.go(-1)
            //     this.$router.push({
            //     name: 'searchForm',
            //     query: { ...this.$route.query,first: 1}
            // })
                this.setChooseMes(data);
            },
            /*
            * 存储选择过的信息
            * */
            setChooseMes(data) {
                // 存储信息
                const modelMes = {
                    brand: {
                        code: data.brand.code,
                        name: data.brand.name,
                        image: data.brand.image,
                    },
                    series: {
                        code: data.series.code,
                        name: data.series.name,
                    },
                    model: {
                        code: data.model.code,
                        name: data.model.name,
                        year: data.model.modelYear,
                    }
                };
                this.setChooseHistory(data);
   
                this.localStorageFun('modelEvaluation', JSON.stringify(modelMes));
            },
            localStorageFun(keyName, data) {
                localStorage.removeItem(keyName);
                localStorage.setItem(keyName, data);
            },
            /*
            * 存储历史信息
            * */
            setChooseHistory(data) {
                // 排重
                this.historyData.forEach((item, idx) => {
                    if (item.code === data.brand.code) {
                        this.historyData.splice(idx, 1);
                    }
                });
                this.historyData.unshift({
                    code: data.brand.code,
                    name: data.brand.name,
                    image: data.brand.image
                });
                this.localStorageFun("historyEvaluation", JSON.stringify(this.historyData));
            },

            onSelectedBrand(data) {
                this.selectedBrands = data;
            },
            openSeriesSection(brandItem) {
                this.$refs.carPicker.openSeriesSection(brandItem);
            },
            resultClick(item) {
                this.searchValue = item;
                this.getSeriesData.forEach((value) => {
                    if (value.seriesName) {
                        if (value.seriesName === item) {
                            this.value = {
                                brand: {
                                    "code": value.brandCode,
                                    "name": value.brandName,
                                    "image": ''
                                },
                                series: {
                                    "code": value.seriesCode,
                                    "name": value.seriesName,
                                }
                            };
                            this.showPicker = true;
                        }
                    } else {
                        if (value.brandName === item) {
                            this.value = {
                                brand: {
                                    "code": value.brandCode,
                                    "name": value.brandName,
                                    "image": ''
                                }
                            };
                            this.showPicker = true;
                        }
                    }
                });
            },
            getResult(keyWord) {
                this.results = [];
                if (!keyWord) {
                    return;
                }
                this.noResultMsg = '正在加载';
                Api.querySuggest(
                    {
                        keyWord,
                        indexName: 'car',
                        userId: this.$route.query.userId ? this.$route.query.userId : ''
                    }).then((res) => {
                    if (Number(res.code) === 200) {
                        this.getSeriesData = res.data;
                        this.results = [];
                        if (res.data.length === 0) {
                            this.noResultMsg = '抱歉， 暂无相关信息';
                        }
                        res.data.forEach((item) => {
                            if (!item.seriesName) {
                                this.results.push(item.brandName);
                            } else {
                                this.results.push(item.seriesName);
                            }
                        })
                    }
                });
            },
            onFocus() {
                this.showPicker = false;
            },
            onCancel() {
                this.showPicker = true;
            },
            onselectText(v) {
                console.log(v);
            },
            onSubmit() {
                this.$refs.search.setBlur();
            },
            /**
             *根绝车系获取变速箱，排油量的过滤选项
             */
            getFilterOptions(seriesCode){
                Api.getFilterTags(
                    {
                        seriesCode:seriesCode,
                        userId: this.$route.query.userId ? this.$route.query.userId : ''
                    }).then((res) => {
                    if (res.IsError || Number(res.code) !== 200) {
                        res.IsError ? this.toastFun("网络异常，请稍后再试") : '';
                        return;
                    }
                    if (Number(res.code) === 200) {
                        this.gearBoxFilterOptions = res.data.gearbox.list;
                        this.engineFilterOptions = res.data.engineVolume.list;
                    }
                });
            }
        },
        mounted() {
            if (localStorage.getItem("modelEvaluation")) {
                if(!(JSON.parse(localStorage.getItem("modelEvaluation")).hasOwnProperty('isVinCarModel'))){
                    this.value = JSON.parse(localStorage.getItem("modelEvaluation"));
                }
            }
            if (localStorage.getItem("historyEvaluation")) {
                this.historyData = JSON.parse(localStorage.getItem("historyEvaluation")).slice(0, 10);
            }
        },
        created() {
            this.headerFn();
        }
    };
</script>
<style scoped>
    .car-picker-demo-wrapper {
        position: relative;
        height: 100vh;
    }

    .picker-content {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
    }

    .selector-item-body-custom {
        padding: .16rem .32rem 0 .1rem;
    }

    .card-item {
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        width: 20%;
        margin-bottom: .15rem;
        display: -webkit-inline-flex;
        -webkit-align-items: center;
    }

    .card-item-span {
        font-size: .12rem;
        margin-top: .1rem;
        color: #1A1A1A;
    }

    .car-picker-demo-select-group {
        padding: .12rem;
    }

    .card-item-image {
        width: .32rem;
    }

    .card-item-selected .card-item-span {
        color: #FF571A;
    }
    .choose-container .som-tag-group--three-column {
        display: -webkit-flex;
    }
    .brand-loading{
        position: fixed;
        top: 55px;
        padding: 2.8rem 0;
        width: 100%;
        line-height: 0.5rem;
        text-align: center;
        box-sizing: border-box;
        height: calc(100% - 55px);
        background: #FFF;
        color: #979797;
        font-size: 0.13rem;
    }
    .brand-loading .img{
        display: block;
        width: 0.2rem;
        height: 0.2rem;
        background: url("../../assets/img/carLoading.png") no-repeat center;
        background-size: 100% 100%;
        margin: 0.05rem auto 0 auto;
        animation:load 1s infinite linear;
    }
    @-webkit-keyframes load {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
</style>
<style>
    .choose-container .sob-search-bar .sob-search{
        display: -webkit-flex;
        -webkit-align-items: center;
        padding: 10px 16px;
    }
    .choose-container .sob-search-bar .sob-search .sob-search__form {
        display: -webkit-flex;
        -webkit-align-items: center;
        -webkit-flex: auto;
    }
    .choose-container .card-item{
        /* autoprefixer: off */
        -webkit-flex-direction: column;
        /* autoprefixer: on */
    }
    .choose-container .som-selector-alphabet__content--item{
        color: #4DA6FF;
    }
    .choose-container .som-selector-alphabet{
        background-color: transparent;
        width: 30px;
    }
    .choose-container .sob-search-bar .sob-search .sob-search__form {
        border-radius: 20px;
    }
    .choose-container .sob-search-bar .sob-search .sob-search-input__box .sob-search__input{
        height: 35px;
    }
    .choose-container .som-selector-group--transition{
        transition-duration:0.2s!important;
        transition-timing-function: linear;
    }
    .choose-container .som-tag--primary.som-tag--plain{
        background-color: rgba(255,87,26,0.1);
    }
</style>



// WEBPACK FOOTER //
// src/components/brandSelector/brandSelector.vue